import { useState } from 'react';
import { useGame } from '../state/useGame';

export function SettingsPage() {
  const settings = useGame((s) => s.state.settings);
  const exportSave = useGame((s) => s.exportSave);
  const importSave = useGame((s) => s.importSave);
  const setVolume = useGame((s) => s.setVolume);
  const [importText, setImportText] = useState('');

  return (
    <>
      <h1 className="page-title">Settings</h1>

      <div className="card">
        <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>Audio</h2>
        <p style={{ color: 'var(--ui-text-dim)', fontSize: 12, marginTop: 0 }}>
          Adjust sound effects and background music. Changes save immediately.
        </p>
        <label style={{ display: 'block', marginTop: 8 }}>
          Sound volume: <strong>{Math.round(settings.soundVolume * 100)}%</strong>
          <input
            type="range"
            min={0}
            max={100}
            value={Math.round(settings.soundVolume * 100)}
            onChange={(event) => setVolume('soundVolume', Number(event.target.value) / 100)}
            style={{ width: '100%' }}
          />
        </label>
        <label style={{ display: 'block', marginTop: 8 }}>
          Music volume: <strong>{Math.round(settings.musicVolume * 100)}%</strong>
          <input
            type="range"
            min={0}
            max={100}
            value={Math.round(settings.musicVolume * 100)}
            onChange={(event) => setVolume('musicVolume', Number(event.target.value) / 100)}
            style={{ width: '100%' }}
          />
        </label>
      </div>

      <div className="card">
        <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>Save</h2>
        <p style={{ color: 'var(--ui-text-dim)', fontSize: 12, marginTop: 0 }}>
          Saves autosave to localStorage every 30s and on action-completed. Export a
          .json file to back up or share.
        </p>
        <button className="primary" onClick={exportSave}>Export save (.json)</button>
        <details style={{ marginTop: 14 }}>
          <summary style={{ cursor: 'pointer' }}>Import save (paste JSON)</summary>
          <textarea
            value={importText}
            onChange={(e) => setImportText(e.target.value)}
            rows={8}
            style={{
              width: '100%',
              marginTop: 8,
              background: 'var(--ui-bg)',
              color: 'var(--ui-text)',
              border: '1px solid var(--ui-border)',
              borderRadius: 6,
              padding: 8,
              fontFamily: 'ui-monospace, Menlo, monospace',
              fontSize: 12,
            }}
            placeholder='{"version":1,...}'
          />
          <button
            style={{ marginTop: 8 }}
            disabled={!importText.trim()}
            onClick={() => {
              const ok = importSave(importText);
              if (ok) setImportText('');
            }}
          >
            Import
          </button>
        </details>
      </div>

      <div className="card">
        <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>About</h2>
        <p>
          <strong>Herman Idle — An AI Butler's Grind.</strong> A Melvor-descendant browser RPG.
        </p>
        <p style={{ color: 'var(--ui-text-dim)', fontSize: 12 }}>
          v0.2.0 · lives at <code>herman/hermanity-idle</code> · designed for{' '}
          <a href="https://idle.hermanity.dev" style={{ color: 'var(--accent-nous)' }}>idle.hermanity.dev</a>{' '}
          (public alpha).
        </p>
      </div>
    </>
  );
}